import React, {useEffect, useState} from "react";
import {useForm, Controller} from "react-hook-form";
import {
    allRegions,
    allIndustries,
    allCountries,
    comparedTo,
} from "../../../utils/const/IntelligenceReportConsts";
import styled from "styled-components";
import Select from "react-select";
import {useMutation, useQuery} from "react-query";
import {userDetails} from "../../../utils/const/query-key";
import apiService from "../../../api/apiService";
import Loading from "../Loading";
import {presentationDownloader} from "../../../utils/blobDownloader";
import moment from 'moment';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 465px;

  .alert {
    color: red;
    font-weight: bold;
  }
`;

export const InputContainer = styled.div`
  margin: 20px;
`;

const RadioInput = styled.input`
  cursor: pointer;
  margin: 10px;
  accent-color: var(--color-brand-pink-primary);
`;

export const Description = styled.div`
  font-size: 14px;
  color: var(--color-form-font-description);
  margin-bottom: 5px;
`;

const SubmitInput = styled.input`
  margin-top: 20px;
  color: white;
  border: none;
  width: 150px;
  height: 36px;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  background-color: var(--color-brand-pink-primary);

  &:hover {
    box-shadow: 0px 0px 15px -5px rgba(236, 64, 122, 100);
  }
`;

export const customTheme = (theme) => {
    return {
        ...theme,
        colors: {
            ...theme.colors,
            primary: "#ec407a",
            primary25: "#FDEBF1",
            dangerLight: "#FDEBF1",
            neutral10: "#FDEBF1",
        },
        width: 465
    };
};

const LocationTab = () => {
    const {data: userData, isLoading: isUserData } = useQuery(userDetails, () => apiService.getUser());
    const [isDataFilled, setIsDataFilled] = useState({
        countriesOrRegionFilled: "",
        industryFilled: "",
    });
    const [locationFormData, setLocationFormData] = useState({
        type: "location",
        is_by_country: true,
        user: "",
        countries: "",
        regions: "",
        industry: "",
        compare_to: "Global",
    });

    useEffect(()=>{
        if(!isUserData){
            setLocationFormData(prev => ({
                ...prev,
                user: userData?.userName,
            }));
        }
    },[isUserData, userData?.userName])


    const {mutate: downloadPresentation, isLoading} = useMutation(
        (formData) =>
            apiService.downloadIntelligenceReportByLocation(formData),
        {
            onSuccess: async (res) => {
                let dateTime = new Date();
                const location = locationFormData.is_by_country ?
                    locationFormat(locationFormData.countries) :
                    locationFormat(locationFormData.regions);
                dateTime = moment(dateTime).format('YYYY-MM-DD HH:mm:ss');
                const fileName = location + "_" + locationFormData.industry + "_" + dateTime;
                await presentationDownloader(res, fileName);

                apiService.contentCreated(locationFormData, "Intelligence").catch(console.error);
            },
        }
    );

    const locationFormat = (location) => {
        return location.replace(new RegExp(",", "g"), '_');
    }



    const onChangeData = (onChange, fieldName, value, onChangeValue = null) => {
        onChange(onChangeValue ? onChangeValue : value);
        setLocationFormData({
            ...locationFormData,
            [fieldName]: value,
        });
    };

    const formSubmit = () => {
        if (isDataFilled.countriesOrRegionFilled || isDataFilled.industryFilled) {
            const dataToSend = { ...locationFormData };
            locationFormData.is_by_country ? delete dataToSend.regions : delete dataToSend.countries;
            downloadPresentation(dataToSend);
        } else {
            setIsDataFilled({
                ...isDataFilled,
                countriesOrRegionFilled: Boolean(isDataFilled.countriesOrRegionFilled),
                industryFilled: Boolean(isDataFilled.industryFilled),
            });
        }
    };
    const {handleSubmit, control} = useForm();

    if (isLoading === true) {
        return <Loading/>;
    }
    return (
        <div>
            <Form onSubmit={handleSubmit(() => formSubmit())}>
                <InputContainer>
                    <Description>
                        Requested Location <span style={{color: "red"}}>*</span>
                    </Description>
                    <label style={{cursor: "pointer"}}>
                        <RadioInput
                            style={{marginLeft: 0}}
                            type="radio"
                            name="location"
                            value="country"
                            id="country"
                            defaultChecked
                            onClick={() => {
                                setIsDataFilled({
                                    ...isDataFilled,
                                    countriesOrRegionFilled: "",
                                });
                                setLocationFormData({
                                    ...locationFormData,
                                    regions: "",
                                    is_by_country: true,
                                });
                            }}
                        />
                        Country
                    </label>
                    <label style={{cursor: "pointer"}}>
                        <RadioInput
                            type="radio"
                            name="location"
                            value="region"
                            id="region"
                            onClick={() => {
                                setIsDataFilled({
                                    ...isDataFilled,
                                    countriesOrRegionFilled: "",
                                });
                                setLocationFormData({
                                    ...locationFormData,
                                    countries: "",
                                    is_by_country: false,
                                });
                            }}
                        />
                        Region
                    </label>
                    <br/>

                    {locationFormData.is_by_country && (
                        <Controller
                            control={control}
                            name="countries"
                            render={({field}) => (
                                <Select
                                    placeholder={"Select Country"}
                                    id={"select_country_dropdown"}
                                    theme={customTheme}
                                    inputRef={field.ref}
                                    onChange={(val) =>
                                        onChangeData(
                                            field.onChange,
                                            "countries",
                                            val.map((c) => c.value).join(","),
                                            setIsDataFilled({
                                                ...isDataFilled,
                                                countriesOrRegionFilled: true,
                                            })
                                        )
                                    }
                                    options={allCountries}
                                    value={locationFormData?.countries.split(",").map(country=>allCountries.find(countryLabel=>countryLabel.label===country))}
                                    isMulti
                                />
                            )}
                        />
                    )}
                    {!locationFormData.is_by_country && (
                        <Controller
                            control={control}
                            name="regions"
                            render={({field}) => (
                                <Select
                                    placeholder={"Select Region"}
                                    theme={customTheme}
                                    inputRef={field.ref}
                                    onChange={(val) =>
                                        onChangeData(
                                            field.onChange,
                                            "regions",
                                            val.map((c) => c.value).join(","),
                                            setIsDataFilled({
                                                ...isDataFilled,
                                                countriesOrRegionFilled: true,
                                            })
                                        )
                                    }
                                    options={allRegions}
                                    isMulti
                                />
                            )}
                        />
                    )}
                </InputContainer>

                <InputContainer>
                    <Description>
                        Compare To
                    </Description>
                    {locationFormData.is_by_country === ""}
                    <Controller
                        defaultValue={1}
                        name={"compare_to"}
                        control={control}
                        render={({field}) => (
                            <Select
                                placeholder={"Global"}
                                id={"compare_to_dropdown"}
                                {...field}
                                theme={customTheme}
                                options={comparedTo}
                                onChange={(val) => {
                                    onChangeData(field.onChange, "compare_to", val.value, val);
                                }}
                            />
                        )}
                    />
                </InputContainer>

                <InputContainer>
                    <Description>Industry</Description>
                    <Controller
                        name="industries"
                        control={control}
                        render={({field}) => (
                            <Select
                                id={"industry_dropdown"}
                                {...field}
                                theme={customTheme}
                                options={allIndustries}
                                placeholder={"Select"}
                                onChange={(val) => {
                                    setIsDataFilled({...isDataFilled, industryFilled: true});
                                    onChangeData(field.onChange, "industry", val.value, val)
                                }
                                }
                            />
                        )}
                    />
                </InputContainer>

                <SubmitInput
                    type="submit"
                    value="Generate Report"
                    id="GenerateLocationReport"
                />
                {isDataFilled.countriesOrRegionFilled === false && isDataFilled.industryFilled === false && (
                    <p className="alert">Please choose a country or a region or an industry</p>
                )}
            </Form>
        </div>
    );
};

export default LocationTab;
